import MarkdownPreview from "@/component/Markdown/MarkdownPreview";
import summaryStore from "@/store/summary.store";
import summarySrcStore from "@/store/summarySrc.store";
import formatMarkdown from "@/utils/formatMarkdown";

const MeetingContent = () => {
  const summary = summaryStore((state) => state.summary);
  const detailInfo = summarySrcStore((state) => state.detailInfo);

  const originContent = formatMarkdown(summary?.srcAiGcContent?.content, detailInfo?.useMarkDownSummary);

  return (
    <>
      <div className="mt-1.5 text-3.5 select-text">
        <MarkdownPreview className="mt-2.5 lh-7 text-justify font-normal select-text text-#30343C" value={originContent} />
      </div>
    </>
  );
};

export default MeetingContent;
